import { useState, useEffect } from "react";
import {
  CasesRounded,
  DeleteForever,
  ModeEditOutline,
  MoreVert,
} from "@mui/icons-material";
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  useTheme,
} from "@mui/material";
import { ConfirmDeleteCaseDialog, EditCaseMetaDataDialog } from "../dialogs";
import { useModals } from "../../store/dialogs/hooks";

export const CaseTitleBarMenu = ({ color, readOnly, af_case, onChange }) => {
  const theme = useTheme();
  const {
    openCaseDetailsDialog,
    openDeleteCaseDialog,
    showCaseDetailsDialog,
    showDeleteCaseDialog,
  } = useModals();
  const [anchorEl, setAnchorEl] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);

  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);

  const handlePropertiesClick = () => {
    setAnchorEl(null);
    openCaseDetailsDialog(af_case.id);
  };

  const handleDeleteCaseClick = () => {
    if (!readOnly) {
      setAnchorEl(null);
      openDeleteCaseDialog(af_case.id);
    }
  };

  const handleMenuClose = () => setAnchorEl(null);

  useEffect(() => {
    if (!showCaseDetailsDialog && !showDeleteCaseDialog && !firstLoad) {
      onChange();
    }
    if (showCaseDetailsDialog || showDeleteCaseDialog) {
      setFirstLoad(false);
    }
  }, [firstLoad, showCaseDetailsDialog, showDeleteCaseDialog]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Tooltip title="Case Settings">
        <IconButton
          aria-label="menu"
          aria-haspopup="true"
          onClick={handleMenuOpen}
        >
          <MoreVert
            sx={{
              color:
                color === "light"
                  ? theme.palette.primary.contrastText
                  : theme.palette.primary.dark,
              height: 1,
            }}
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handlePropertiesClick} sx={{ gap: 1 }}>
          <IconButton aria-label="Edit Case Details" color="inherit">
            <ModeEditOutline />
          </IconButton>
          {readOnly ? "View" : "Edit"} Case Details
        </MenuItem>
        <MenuItem disabled sx={{ gap: 1 }}>
          <IconButton aria-label="Backup Complete Case" color="inherit">
            <CasesRounded />
          </IconButton>
          Backup Complete Case
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleDeleteCaseClick}
          disabled={readOnly}
          sx={{ color: theme.palette.error.main, gap: 1 }}
        >
          <IconButton color="inherit" aria-label="Delete Case">
            <DeleteForever />
          </IconButton>
          Delete Case
        </MenuItem>
      </Menu>
      <EditCaseMetaDataDialog af_case={af_case} readOnly={readOnly} />
      <ConfirmDeleteCaseDialog af_case={af_case} />
    </>
  );
};
